<style>
    .page-item {
        cursor: pointer;
    }
    h4 {
        text-transform: capitalize;
    }
    tr.border_top td {
        border-top:1pt solid black;
    }
</style>

<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1>Laporan Neraca</h1>
            </div>
            <div class="section-body">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h4>Neraca</h4>
                                <div class="card-header-form">
                                    <div class="input-group">
                                        <label class="mr-1 font-weight-bold">Per</label>
                                        <vc-date-picker v-model="per_tanggal" :input-props='{class: "form-control",placeholder: "Tanggal",style:"display:inline;"}'/>
                                        <div class="input-group-btn mr-3">
                                            <button class="btn btn-primary"><i class="fa fa-calendar"></i></button>
                                        </div>
                                        <button @click="setFilter()" class="btn btn-outline-primary mr-3">Filter</button>
                                        <button @click="printPage()" class="btn btn-outline-success"> <i class="fas fa-file"></i> Print Neraca</button>
                                        <!-- <a :href="siteUrl+'Laporan/exportExcel/pembelian?tanggal_mulai='+formatDate(tanggal_mulai)+'&tanggal_selesai='+formatDate(tanggal_selesai)+'&tipe='+url[1]" target="_blank" style="padding:7px 0px 0px 0px" class="btn btn-outline-info"><i class="fa fa-file-excel-o"></i> Export to Excel</a> -->
                                    </div>
                                </div>
                            </div>
                            <div id="printMe">
                                <div class="card-body p-0">
                                    <div class="table-responsive">
                                        <table class="table table-md">
                                            <thead>
                                                <tr style="background-color:#dc95dc;">
                                                    <th>#</th>
                                                    <th>Tanggal</th>
                                                    <th></th>
                                                    <th style="text-align:right;padding-right:50px;">{{ per_tanggal | moment("DD MMMM YYYY") }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr style="background-color: rgba(0,0,0,.04);">
                                                    <th></th>
                                                    <th colspan="3">Aset</th>
                                                </tr>
                                                <tr>
                                                    <th></th>
                                                    <th colspan="3"> &nbsp; Aset Lancar</th>
                                                </tr>
                                                <tr v-for="list in neracaLists['aset_lancar']" v-bind:key="list.id_coa" >
                                                    <td></td>
                                                    <td> &nbsp; &nbsp; {{ list.kode_akun }} </td>
                                                    <td> {{ list.nama_akun }} </td>
                                                    <td style="text-align:right;padding-right:50px;"> {{ 'Rp. '+ currencyFormat(list.total_saldo) }}  </td>
                                                </tr>
                                                <tr class="border_top">
                                                    <th></th>
                                                    <th colspan="2"> &nbsp; Total Aset Lancar</th>
                                                    <th style="text-align:right;padding-right:50px;">{{ 'Rp. '+ currencyFormat(neracaLists.total_aset_lancar) }}</th>
                                                </tr>
                                                <tr style="background-color: rgba(0,0,0,.04);">
                                                    <th></th>
                                                    <th colspan="3"> &nbsp; Aset Tetap</th>
                                                </tr>
                                                <tr v-for="list in neracaLists['aset_tetap']" v-bind:key="list.id_coa">
                                                    <td></td>
                                                    <td> &nbsp; &nbsp; {{ list.kode_akun }} </td>
                                                    <td> {{ list.nama_akun }} </td>
                                                    <td style="text-align:right;padding-right:50px;"> {{ 'Rp. '+ currencyFormat(list.total_saldo) }}  </td>
                                                </tr>
                                                <tr class="border_top">
                                                    <th></th>
                                                    <th colspan="2"> &nbsp; Total Aset Tetap</th>
                                                    <th style="text-align:right;padding-right:50px;">{{ 'Rp. '+ currencyFormat(neracaLists.total_aset_tetap) }}</th>
                                                </tr>
                                                <tr class="border_top">
                                                    <th></th>
                                                    <th colspan="2">Total Aset</th>
                                                    <th style="text-align:right;padding-right:50px;">{{ 'Rp. '+ currencyFormat(neracaLists.total_aset_lancar+neracaLists.total_aset_tetap) }}</th>
                                                </tr>
                                                <tr>
                                                    <th colspan="4"></th>
                                                </tr>
                                                <tr style="background-color: rgba(0,0,0,.04);">
                                                    <th></th>
                                                    <th colspan="3">Kewajiban & Modal</th>
                                                </tr>
                                                <tr>
                                                    <th></th>
                                                    <th colspan="3"> &nbsp; Kewajiban Jangka Pendek</th>
                                                </tr>
                                                <tr v-for="list in neracaLists['kewajiban']" v-bind:key="list.id_coa">
                                                    <td></td>
                                                    <td> &nbsp; &nbsp; {{ list.kode_akun }} </td>
                                                    <td> {{ list.nama_akun }} </td>
                                                    <td style="text-align:right;padding-right:50px;"> {{ 'Rp. '+ currencyFormat(list.total_saldo) }}  </td>
                                                </tr>
                                                <tr class="border_top">
                                                    <th></th>
                                                    <th colspan="2"> &nbsp;Total Kewajiban</th>
                                                    <th style="text-align:right;padding-right:50px;">{{ 'Rp. '+ currencyFormat(neracaLists.total_kewajiban) }}</th>
                                                </tr>
                                                <tr>
                                                    <th colspan="4"></th>
                                                </tr>
                                                <tr style="background-color: rgba(0,0,0,.04);">
                                                    <th></th>
                                                    <th colspan="3">Modal Pemilik</th>
                                                </tr>
                                                <tr v-for="list in neracaLists['modal']" v-bind:key="list.id_coa">
                                                    <td></td>
                                                    <td> &nbsp; &nbsp; {{ list.kode_akun }} </td>
                                                    <td> {{ list.nama_akun }} </td>
                                                    <td style="text-align:right;padding-right:50px;"> {{ 'Rp. '+ currencyFormat(list.total_saldo) }}  </td>
                                                </tr>
                                                <tr class="border_top">
                                                    <th></th>
                                                    <th colspan="2"> &nbsp; Total Modal Pemilik</th>
                                                    <th style="text-align:right;padding-right:50px;">{{ 'Rp. '+ currencyFormat(neracaLists.total_modal) }}</th>
                                                </tr>
                                                <tr class="border_top">
                                                    <th></th>
                                                    <th colspan="2">Total Kewajiban dan Modal</th>
                                                    <th style="text-align:right;padding-right:50px;">{{ 'Rp. '+ currencyFormat(neracaLists.total_kewajiban + neracaLists.total_modal) }}</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';


const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css',
    'https://use.fontawesome.com/releases/v5.7.2/css/all.css'
  ]
}

export default {
    
    data() {
        return {
            jenis_pembayaran : '',
            neracaLists : [],
            search: '',
            last: '',
            totalRow: '',
            pagination: [],
            url : '',
            filter : '',
            per_tanggal : new Date(),
            siteUrl : window.location.href.substr(0, window.location.href.indexOf('#')),
        }
    },
    mounted() {
        this.url = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        this.url = this.url.split('-');    
        this.init();
    },
    methods: {
        init: function() {
            this.$root.is_loading = true;
            this.$http.get("Finance/getNeraca?per_tanggal="+this.formatDate(this.per_tanggal)).then(result => {
                if(result.data.code == '00') {
                    alert('failed get Transaksi')
                }
                else {
                    this.neracaLists = result.data.detail;
                }
                this.$root.is_loading = false;
            }, error => {
                this.$root.is_loading = false;
                console.log('gk ok')
                context.errors = errors;
            });
        },
        goTo: function(paths) {
            this.$router.push({ path : paths })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
            // this.$router.go();
        },
        
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        
        setFilter: function() {
            this.init();
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        printPage() {
            this.$htmlToPaper('printMe', () => {
                console.log('Printing done or got cancelled!');
            });
        }
    },
    components : {
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/laporan/Neraca.vue